import { render, staticRenderFns } from "./CompanyComponentView.vue?vue&type=template&id=926fd00c&scoped=true"
import script from "./CompanyComponentView.vue?vue&type=script&lang=js"
export * from "./CompanyComponentView.vue?vue&type=script&lang=js"
import style0 from "./CompanyComponentView.vue?vue&type=style&index=0&id=926fd00c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926fd00c",
  null
  
)

export default component.exports